import { postPaymentPaymentDoneBit } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import Loader from "components/Reusable/Loader"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { PaymentSteps } from "~/pages/payment"
import { usePaymentContext } from "./PaymentContext"
import { getPaymentDataFromLocalStorage } from "./bitHelpers"

const BitPage = () => {
  const {
    setPurchaseData,
    setSelectedGiftCard,
    setBlessingMode,
    setGiftCardLoadAmount,
    setOrderId,
    setOrderRecipientGuid,
  } = usePurchaseContext()

  const { setPaymentSteps } = usePaymentContext()
  const router = useRouter()
  const isDesktop = useIsDesktop()

  useEffect(() => {
    if (!isDesktop) {
      const hasParams = Object.keys(router.query).length > 0
      if (hasParams) {
        const paymentinitiaionid = router.query?.paymentinitiaionid?.toString()
        const orderguid = router.query?.orderguid?.toString()
        if (!paymentinitiaionid || !orderguid) {
          router.push("/")
          return
        }
        updateContextData(orderguid)
        const postBitPayment = async () => {
          const { data } = await postPaymentPaymentDoneBit({
            paymentInitiationId: paymentinitiaionid,
          })
          if (data.body.success) {
            router.push("/payment")
            setPaymentSteps(PaymentSteps.SUCCESS)
            localStorage.removeItem("orderGuid")
          } else {
            router.push("/payment")
            localStorage.removeItem("orderGuid")
          }
        }
        postBitPayment()
      }
    }
  }, [router])

  const updateContextData = (id) => {
    const data = getPaymentDataFromLocalStorage(id)
    if (!data) {
      return
    }
    setPurchaseData(data.purchaseData)
    setSelectedGiftCard(data.selectedGiftCard)
    setBlessingMode(data.blessingMode)
    setGiftCardLoadAmount(data.giftCardLoadAmount)
    setOrderId(data.orderId)
    setOrderRecipientGuid(data.orderRecipientGuid)
  }

  return <Loader />
}

export default BitPage
